export const URL_LEITOR_BIOMETRICO = 'wss://127.0.0.1:8021/bio-wss-haptech/api'

export const ACAO_FINALIZAR = '4'
export const TIPO_IMAGEM_WSQ = 'wsq'

export const TIPO_TOKEN_DIGITAL = '05'
export const TIPO_TOKEN_FACIAL = '06'

export const CNPJ_OPERADORAS_CAPTURA_BIOMETRIA = ['63554067000198', '62550256000120', '44649812000138']
export const CNPJ_OPERADORAS_ATIVACAO_BIOMETRIA = [...CNPJ_OPERADORAS_CAPTURA_BIOMETRIA, '76882612000117']
export const CNPJ_OPERADORAS_FACIAL_GUARDADA = ['05056031000188', '02403281000159']

export const DEDOS_CAPTURA = [
  { label: 'Polegar Direito', value: 1 },
  { label: 'Indicador Direito', value: 2 },
  { label: 'Medio Direito', value: 3 },
  { label: 'Polegar Esquerdo', value: 6 },
  { label: 'Indicador Esquerdo', value: 7 },
  { label: 'Medio Esquerdo', value: 8 }
]

export const dedosCaptura = () => DEDOS_CAPTURA.map((dedo) => ({ ...dedo, collected: false }))
